import { ILayoutRoomCount as IWidgetLayoutRoomCount, ERoomType } from '@cian/frontend-newbuilding-layouts-widget';
import { ERoomsCount, ILayoutRoomCount } from '../../types/newbuilding/layouts';
import { IApplicationState } from '../../types/redux';

const ROOM_TYPE_MAP: { [key in ERoomsCount]: ERoomType } = {
  [ERoomsCount.Studio]: ERoomType.Studio,
  [ERoomsCount.OneRoom]: ERoomType.OneRoom,
  [ERoomsCount.TwoRoom]: ERoomType.TwoRoom,
  [ERoomsCount.ThreeRoom]: ERoomType.ThreeRoom,
  [ERoomsCount.FourPlusRoom]: ERoomType.FourRoom,
};

export const getLayoutsRoomsCountsByHouse = (state: IApplicationState): IWidgetLayoutRoomCount[] => {
  if (!state.newbuilding.layoutsInfo) {
    return [];
  }

  const houseId = state.offers.selectedHouseId || null;

  const roomsCountsByHouse = state.newbuilding.layoutsInfo.roomsCountsByHouse.find(list => list.houseId === houseId);

  if (!roomsCountsByHouse) {
    return [];
  }

  return roomCountMapper(roomsCountsByHouse.roomsCountList);
};

function roomCountMapper(rooms: ILayoutRoomCount[]): IWidgetLayoutRoomCount[] {
  return rooms.map(room => ({
    ...room,
    roomValue: ROOM_TYPE_MAP[room.roomValue],
  }));
}
